import { Prism } from '@mantine/prism';
interface Props {
    snippet: string;
    onCopyToClipboard?: () => void;
}

export default function SnippetBox({ snippet, onCopyToClipboard }: Props) {
    const handleCopyToClipboard = () => {
        onCopyToClipboard?.();
    };

    return (
        <Prism language="jsx" onCopy={handleCopyToClipboard} className="border rounded-lg text-left">
            {snippet}
        </Prism>
    );
}
